import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Membership from '../components/Membership';
import News from '../components/News';
import Events from '../components/Events';
import Contact from '../components/Contact';
import CricketClubTeaser from '../components/CricketClubTeaser';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';

const HomePage = () => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        Promise.all([
            api.get('/content/site'),
            api.get('/content/hero'),
            api.get('/content/about'),
            api.get('/content/membership'),
            api.get('/content/contact'),
            api.get('/content/news'),
            api.get('/content/events'),
            api.get('/news?limit=3'),
            api.get('/events?limit=3'),
        ])
            .then(([site, hero, about, membership, contact, newsMeta, eventsMeta, newsRes, eventsRes]) => {
                const fmtDate = iso => iso
                    ? new Date(iso).toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' })
                    : '';
                const stripHtml = html => {
                    const tmp = document.createElement('div');
                    tmp.innerHTML = html || '';
                    return tmp.textContent || tmp.innerText || '';
                };

                const newsItems = (newsRes.data.articles || []).map(a => ({
                    ...a,
                    image:    a.image_url || '/assets/img/placeholder.svg',
                    imageAlt: a.title,
                    date:     fmtDate(a.published_at),
                    summary:  stripHtml(a.excerpt),
                    label:    a.category || 'News',
                    variant:  'news',
                }));

                const eventItems = (eventsRes.data || []).map(e => ({
                    ...e,
                    image:    e.image_url || '/assets/img/placeholder.svg',
                    imageAlt: e.title,
                    date:     fmtDate(e.event_date),
                    location: e.venue || '',
                    summary:  stripHtml(e.description),
                }));

                setContent({
                    site: site.data,
                    hero: hero.data,
                    about: about.data,
                    membership: membership.data,
                    contact: contact.data,
                    news: { ...newsMeta.data, items: newsItems },
                    events: { ...eventsMeta.data, items: eventItems },
                });
                setLoading(false);
            })
            .catch(error => {
                console.error('Error loading content:', error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!loading && location.hash) {
            const id = location.hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
                setTimeout(() => element.scrollIntoView({ behavior: 'smooth' }), 100);
            }
        }
    }, [loading, location]);

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (!content) {
        return (
            <div className="error-screen">
                <h1>Error loading content</h1>
                <p>Please try again later.</p>
            </div>
        );
    }

    return (
        <div className="App">
            <MetaTags
                title="Melbourne Nepalese Community West | MNCW"
                description="Melbourne Nepalese Community West (MNCW) - Connecting and supporting the Nepali community in Melbourne's western suburbs through cultural events, community programs, and social activities."
                url="https://mncw.org.au/"
                image="https://mncw.org.au/assets/img/logo.jpg"
                type="website"
            />
            <Header data={content.site} />
            <Hero data={content.hero} />
            <About data={content.about} />
            <Membership data={content.membership} />
            <News data={content.news} />
            <Events data={content.events} />
            <CricketClubTeaser />
            <Contact data={content.contact} />
            <Footer data={content.site} />
        </div>
    );
};

export default HomePage;
